// import { LendingNavigationItem } from "./items/lending-navigation-item"
import { DashboardNavigationItem } from "./items/dashboard-navigation-item"
import { LiquidityNavigationItem } from "./items/liquidity-navigation-item"
import { LockNavigationItem } from "./items/lock-navigation-item"
import { MoreNavigationItem } from "./items/more-navigation-item"
import { SwapNavigationItem } from "./items/swap-navigation-item"
import { ActiveStateAnyStartsWithStrategy } from "./strategies/active-state-any-starts-with-strategy"
import { ActiveStateStartsWithStrategy } from "./strategies/active-state-starts-with-strategy"

// const lendingNavigationItem = new LendingNavigationItem()
const dashboardNavigationItem = new DashboardNavigationItem()
const liquidityNavigationItem = new LiquidityNavigationItem()
const lockNavigationItem = new LockNavigationItem()
const moreNavigationItem = new MoreNavigationItem()
const swapNavigationItem = new SwapNavigationItem()

// Now add custom active strategies
dashboardNavigationItem.setActiveStrategy(new ActiveStateStartsWithStrategy("/dashboard"))
liquidityNavigationItem.setActiveStrategy(new ActiveStateStartsWithStrategy("/liquidity"))
lockNavigationItem.setActiveStrategy(new ActiveStateStartsWithStrategy("/lock"))
// lendingNavigationItem.setActiveStrategy(new ActiveStateStartsWithStrategy("/lending"))
moreNavigationItem.setActiveStrategy(
  new ActiveStateAnyStartsWithStrategy(["/more", "/protocols", "/docs", "/diagnostics", "/treasury"]),
)

export const navItems = [
  dashboardNavigationItem,
  swapNavigationItem,
  liquidityNavigationItem,
  lockNavigationItem,
  // lendingNavigationItem,
  moreNavigationItem,
]
